"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
require("react-dates/initialize");
var classNames = require("classnames");
require("core-js");
var moment = require("moment");
var React = require("react");
var react_dates_1 = require("react-dates");
var Cooltip_1 = require("../Cooltip");
require("react-dates/lib/css/_datepicker.css");
require("./DatePicker.scss");
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.highlightTodayFunc = function (day) {
            return react_dates_1.isSameDay(day, moment());
        };
        _this.initialMonth = function () {
            return _this.props.date ? moment(_this.props.date) : null || _this.props.initialDisplayDate ? moment(_this.props.initialDisplayDate) : null || moment();
        };
        _this.isDayBlocked = function (day) {
            if (_this.props.disabledDays && _this.props.disabledDays.indexOf(day.weekday()) !== -1) {
                return true;
            }
            return false;
        };
        _this.state = {
            isFocused: false,
        };
        // tslint:disable-next-line:no-string-literal
        moment.locale(navigator.languages ? navigator.languages[0] : (navigator.language || navigator['userLanguage']));
        _this.onFocusChange = _this.onFocusChange.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    DatePicker.prototype.onChange = function (date) {
        if (this.props.datesTimestampedMidnight) {
            if (date) {
                date = date.subtract(12, 'h');
            }
        }
        if (date === this.props.date) {
            return;
        }
        this.props.onDateChange(date);
    };
    DatePicker.prototype.render = function () {
        var rangeFunc = this.props.isOutsideRange;
        if (!this.props.isOutsideRange) {
            rangeFunc = function () { return false; };
        }
        var validationClass = '';
        if (this.props.validationState === 'invalid') {
            validationClass = 'invalid';
        }
        else if (this.props.validationState === 'valid') {
            validationClass = 'valid';
        }
        var datePickerClassNames = classNames({}, validationClass);
        var datePicker = (React.createElement("div", { className: datePickerClassNames },
            React.createElement(react_dates_1.SingleDatePicker, { isDayBlocked: this.isDayBlocked, firstDayOfWeek: this.props.firstDayOfWeek, date: this.props.date || null, disabled: this.props.disabled, onDateChange: this.onChange, id: this.props.id, focused: this.state.isFocused, onFocusChange: this.onFocusChange, placeholder: this.props.placeholder || moment.localeData().longDateFormat('L'), numberOfMonths: 1, isOutsideRange: rangeFunc, isDayHighlighted: this.highlightTodayFunc, initialVisibleMonth: this.initialMonth, verticalSpacing: 10, hideKeyboardShortcutsPanel: true })));
        if (this.props.validationState === 'invalid'
            && this.props.errorMessage
            && this.props.errorMessage !== '') {
            return React.createElement(Cooltip_1.Cooltip, { tooltipType: 'error', tooltipContents: React.createElement("span", null, this.props.errorMessage), placement: 'bottom' }, datePicker);
        }
        else {
            return React.createElement(Cooltip_1.Cooltip, { tooltipType: 'default', hidden: true, tooltipContents: React.createElement("span", null), placement: 'bottom' }, datePicker);
        }
    };
    DatePicker.prototype.onFocusChange = function (_a) {
        var focused = _a.focused;
        this.setState({
            isFocused: focused
        });
    };
    return DatePicker;
}(React.Component));
exports.DatePicker = DatePicker;
var Weekday;
(function (Weekday) {
    Weekday[Weekday["sunday"] = 0] = "sunday";
    Weekday[Weekday["monday"] = 1] = "monday";
    Weekday[Weekday["tuesday"] = 2] = "tuesday";
    Weekday[Weekday["wednesday"] = 3] = "wednesday";
    Weekday[Weekday["thursday"] = 4] = "thursday";
    Weekday[Weekday["friday"] = 5] = "friday";
    Weekday[Weekday["saturday"] = 6] = "saturday";
})(Weekday = exports.Weekday || (exports.Weekday = {}));
//# sourceMappingURL=DatePicker.js.map